import { render, staticRenderFns } from "./MyNpa.vue?vue&type=template&id=28e45812&scoped=true"
import script from "./MyNpa.vue?vue&type=script&lang=js"
export * from "./MyNpa.vue?vue&type=script&lang=js"
import style0 from "./MyNpa.vue?vue&type=style&index=0&id=28e45812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e45812",
  null
  
)

export default component.exports